import {Component, inject} from '@angular/core';
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {LocaleService} from "../../../../locale/locale.service";
import {FooterComponent} from "../../../common/footer/footer.component";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-about-signal-iduna',
  imports: [
    AdditionalActionHeaderComponent,
    FooterComponent,
    NgOptimizedImage,
  ],
  templateUrl: './about-insurer.component.html',
  styleUrl: './about-insurer.component.css'
})
export class AboutInsurerComponent {
  locale = inject(LocaleService);
}
